import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { invoicesActionCreators } from '../../data/invoices/invoicesAction';
import { ApiInvoicesState } from '../../data/invoices/invoicesModels';
// tslint:disable-next-line:no-var-requires
const invoices = require('../../resources/invoices.png');
import * as moment from 'moment';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';
import './invoices.css';

/* tslint:disable */
type InvoicesProps = InvoicesState & // ... state we've requested from the Redux store
    InvoicesActions & // ... plus action creators we've requested
    RouteComponentProps<{}>;

interface InvoicesState {
    header: HeaderState;
    invoices: ApiInvoicesState;
}

interface InvoicesActions {
    headerActions: typeof headerActionCreators;
    invoicesActions: typeof invoicesActionCreators;
}

interface State {
    popoverOpen: boolean;
    tHead: Array<RowObject>;
    InvoiceList: Array<Tbody>;
}

class Invoices extends React.Component<InvoicesProps, State> {
    constructor(props: InvoicesProps) {
        super(props);
        this.state = {
            popoverOpen: false,
            tHead: [
                new RowObject(DataType.string, 'Due Date', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Invoice Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Order Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'PO Number', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Company Name', undefined, undefined, 'pointer'),
                new RowObject(DataType.string, 'Balance', undefined, undefined, 'pointer')
            ],
            InvoiceList: []
        };
        this.getTbody = this.getTbody.bind(this);
        this.getInvoice = this.getInvoice.bind(this);
    }

    getInvoice(orderId: string) {
        this.props.history.push('/invoice/' + orderId);
    }

    componentWillMount() {
        if (this.props.invoices.invoices.length > 0) {
            this.getTbody(this.props);
        }
    }

    componentWillUpdate(nextProps: InvoicesProps) {
        if (nextProps.invoices.invoices.length !== this.props.invoices.invoices.length) {
            this.getTbody(nextProps);
        }
    }

    getTbody(props: InvoicesProps) {
        let invoiceList = new Array<Tbody>();

        invoiceList = props.invoices.invoices.map((data) => {
            let rBody = new Array<RowObject>();

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.dueDate ? moment(data.dueDate, 'M/D/YYYY').format('M/D/YYYY') : '',
                    null,
                    undefined,
                    undefined
                )
            );

            rBody.push(
                new RowObject(DataType.string, data.invoiceNumber ? data.invoiceNumber : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(DataType.string, data.orderNumber ? data.orderNumber : '', null, undefined, undefined)
            );

            rBody.push(new RowObject(DataType.string, data.poNumber ? data.poNumber : '', null, undefined, undefined));

            rBody.push(
                new RowObject(DataType.string, data.shiptoname ? data.shiptoname : '', null, undefined, undefined)
            );

            rBody.push(
                new RowObject(
                    DataType.string,
                    data.balance
                        ? data.balance.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                          })
                        : '',
                    null,
                    undefined,
                    undefined
                )
            );
            let row = new Tbody(rBody, data.invoiceId, this.getInvoice.bind(this));

            return row;
        });
        this.setState({ InvoiceList: invoiceList });
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Invoices'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={invoices} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.InvoiceList != null && this.state.InvoiceList.length > 0 ? (
                    <Table
                        tHead={this.state.tHead}
                        tBody={this.state.InvoiceList}
                        listSize={this.state.InvoiceList.length}
                        hover={true}
                        cursor={true}
                        hidePagination={true}
                        americanDateFormat={true}
                    />
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): InvoicesState {
    return {
        header: state.header,
        invoices: state.invoices
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): InvoicesActions {
    return {
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        invoicesActions: bindActionCreators(invoicesActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Invoices)
);



// WEBPACK FOOTER //
// ./src/containers/invoices/invoices.tsx